const resources = {
    new: 'new',
    aiChatInputPlaceholderPdp: 'Ask any question about this product',
    aiChatInputPlaceholderPlp: 'Need help finding a product?',
    aiChatInputPlaceholderPlpLgUi: 'Need product help?',
    aiChatInputPlaceholderCms: 'Need help finding a product?',
    aiChat: 'AI Chat'
};

export default function getResource(label) {
    return resources[label];
}
